import React, { useState } from 'react';
import { ArrowLeftIcon, EyeIcon, EyeOffIcon, SmartphoneIcon } from 'lucide-react';
import { toast } from 'sonner';
import type { FieldRole } from '../../types/config';
import { FIELD_USERS } from '../../data/users';
import { useStore } from '../../contexts/StoreContext';
import { DmpLogo } from '../../components/brand/DmpLogo';
import { BdFlag } from '../../components/brand/BdFlag';
import { Modal } from '../../components/shared/Modal';
export function FieldLogin({
  onLogin,
  onExit
}: {
  onLogin: (r: FieldRole) => void;
  onExit: () => void;
}) {
  const {
    config
  } = useStore();
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const [unit, setUnit] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [device, setDevice] = useState(false);
  const [deviceOk, setDeviceOk] = useState(false);
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!id.trim() || !pw.trim() || !unit) {
      setError('মোবাইল নম্বর / কর্মকর্তা আইডি, পাসওয়ার্ড ও দায়িত্বপ্রাপ্ত ইউনিট পূরণ করুন।');
      return;
    }
    const match = (Object.keys(FIELD_USERS) as FieldRole[]).find(k => FIELD_USERS[k].staffId.toLowerCase() === id.trim().toLowerCase());
    if (!match) {
      setError('আইডি বা পাসওয়ার্ড সঠিক নয়। ডেমো অ্যাকাউন্ট ব্যবহার করুন।');
      return;
    }
    onLogin(match);
  };
  return <div className="flex flex-1 flex-col overflow-y-auto bg-white" data-id="element-2042" data-mp="2r272ims326u1">
      <div className="bg-navy px-5 pb-10 pt-4 text-white" data-id="element-2043" data-mp="2w235qjsyhu8j">
        <div className="flex items-center justify-between" data-id="element-2044" data-mp="2w0icqymaijcs">
          <button onClick={onExit} className="lg:hidden flex items-center gap-1 text-xs text-white/80" data-id="element-2045" data-mp="3116dic0bmek7"><ArrowLeftIcon className="h-4 w-4" data-id="element-2046" data-mp="353je6m07nma4" /> ডেমো হোম</button>
          <span className="lg:hidden" data-id="element-2047" data-mp="350ow314o6djv" />
          <BdFlag width={26} data-id="element-2048" data-mp="16o6t85kzww6l" />
        </div>
        <div className="mt-4 flex flex-col items-center text-center" data-id="element-2049" data-mp="16phunyqyxruj">
          <DmpLogo size={72} tone="light" data-id="element-2050" data-mp="1apryp5v7a86r" />
          <h1 className="mt-3 text-xl font-bold leading-snug" data-id="element-2051" data-mp="1aqtka49ued2q">ডিএমপি যানবাহন হেফাজত ব্যবস্থাপনা</h1>
          <p className="text-xs text-white/75" data-id="element-2052" data-mp="2e1qx47vb0n0l">মাঠ পর্যায়ের কর্মকর্তা অ্যাপ</p>
        </div>
      </div>
      <form onSubmit={submit} className="-mt-6 mx-4 card p-4 space-y-3" noValidate data-id="element-2053" data-mp="2n0m7lw5dsj9p">
        <div data-id="element-2054" data-mp="2my9ecmu6amhc">
          <label className="label" htmlFor="fid" data-id="element-2055" data-mp="2iz0m5mes6wnw">মোবাইল নম্বর / কর্মকর্তা আইডি</label>
          <input id="fid" className="input" placeholder="যেমন: WRK-2093" value={id} onChange={e => setId(e.target.value)} data-id="element-2056" data-mp="2j1ddgq6fijdm" />
        </div>
        <div data-id="element-2057" data-mp="2s0gxbwdf72t6">
          <label className="label" htmlFor="fpw" data-id="element-2058" data-mp="2rynlm2ny9seb">পাসওয়ার্ড</label>
          <div className="relative" data-id="element-2059" data-mp="36obq1crfh769">
            <input id="fpw" type={show ? 'text' : 'password'} className="input pr-10" placeholder="পাসওয়ার্ড লিখুন" value={pw} onChange={e => setPw(e.target.value)} data-id="element-2060" data-mp="36na4gecsd2aa" />
            <button type="button" onClick={() => setShow(!show)} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-ink-soft" aria-label="পাসওয়ার্ড দেখান" data-id="element-2061" data-mp="3foqe2jvs10dg">
              {show ? <EyeOffIcon className="h-4 w-4" data-id="element-2062" data-mp="3ubyt5vs7hpup" /> : <EyeIcon className="h-4 w-4" data-id="element-2063" data-mp="3ud05e3kykie0" />}
            </button>
          </div>
        </div>
        <div data-id="element-2064" data-mp="35xg5hookm6f">
          <label className="label" htmlFor="funit" data-id="element-2065" data-mp="34cl7qygf181">দায়িত্বপ্রাপ্ত ইউনিট</label>
          <select id="funit" className="input" value={unit} onChange={e => setUnit(e.target.value)} data-id="element-2066" data-mp="3lc1y9cf83ur7">
            <option value="" data-id="element-2067" data-mp="3pc40pnss8s7j">ইউনিট নির্বাচন করুন</option>
            {config.divisions.map(d => <option key={d.name} data-id="element-2068" data-mp="3bkyycdy15lti">{d.name}</option>)}
            {config.stations.map(s => <option key={s.name} data-id="element-2069" data-mp="3gc79bef0df8s">{s.name}</option>)}
          </select>
        </div>
        {error && <p className="rounded-md bg-danger-50 px-3 py-2 text-xs text-danger-700" role="alert" data-id="element-2070" data-mp="31nb3zp4c6gbv">{error}</p>}
        <button type="submit" className="btn btn-primary btn-lg w-full" data-id="element-2071" data-mp="36me0uma5xg8r">লগইন</button>
        <div className="flex justify-between text-xs" data-id="element-2072" data-mp="36k1gy3kugvt2">
          <button type="button" className="font-semibold text-navy" onClick={() => toast.info('পাসওয়ার্ড পুনরুদ্ধারের জন্য ইউনিট অ্যাডমিনের সাথে যোগাযোগ করুন। (ডেমো)')} data-id="element-2073" data-mp="2snxrsootvdng">পাসওয়ার্ড ভুলে গেছেন?</button>
          <button type="button" className="flex items-center gap-1 font-semibold text-bdgreen" onClick={() => setDevice(true)} data-id="element-2074" data-mp="2pjoy3fz6lc7t">
            <SmartphoneIcon className="h-3.5 w-3.5" data-id="element-2075" data-mp="2ko05xxphqxlj" /> ডিভাইস যাচাইকরণ{deviceOk ? ' ✓' : ''}
          </button>
        </div>
      </form>

      <div className="mx-4 mt-4 mb-6" data-id="element-2076" data-mp="2bu500ngjp34u">
        <p className="mb-2 text-sm font-bold text-ink" data-id="element-2077" data-mp="2bt3okhvmaeml">ডেমো লগইন</p>
        <div className="space-y-2" data-id="element-2078" data-mp="26usec61eu23u">
          {(Object.keys(FIELD_USERS) as FieldRole[]).map(k => <button key={k} onClick={() => onLogin(k)} className="flex w-full items-center justify-between rounded-xl border border-line bg-white px-3.5 py-2.5 text-left hover:bg-navy-50" data-id="element-2079" data-mp="21v5yrpy409rv">
              <div data-id="element-2080" data-mp="1sv94n8syaipf">
                <p className="text-sm font-semibold text-ink" data-id="element-2081" data-mp="1svsmyqmij93z">{FIELD_USERS[k].title}</p>
                <p className="text-xs text-ink-muted" data-id="element-2082" data-mp="3ran860fux2uu">{FIELD_USERS[k].name} · {FIELD_USERS[k].staffId}</p>
              </div>
              <span className="text-xs font-semibold text-navy" data-id="element-2083" data-mp="3n9a2prgof1og">প্রবেশ</span>
            </button>)}
        </div>
      </div>

      <Modal open={device} onClose={() => setDevice(false)} title="ডিভাইস যাচাইকরণ" contained footer={<button className="btn btn-green" onClick={() => {
      setDeviceOk(true);
      setDevice(false);
      toast.success('ডিভাইস যাচাই সম্পন্ন (সিমুলেটেড)।');
    }} data-id="element-2085" data-mp="1iqsrin6uvfpb">যাচাই নিশ্চিত করুন</button>} data-id="element-2084" data-mp="18z6h2t2cdknm">
        <div className="space-y-2 text-sm" data-id="element-2086" data-mp="1muicl2obnf5l">
          <p className="text-ink-muted" data-id="element-2087" data-mp="q2wxxrcl23wr">শুধুমাত্র নিবন্ধিত সরকারি ডিভাইস থেকে লগইন অনুমোদিত।</p>
          <div className="rounded-lg bg-canvas p-3 font-mono text-xs space-y-1" data-id="element-2088" data-mp="v0q2yh25grvg">
            <p data-id="element-2089" data-mp="z337j255ujqn">Device ID: DMP-AND-07-2291</p>
            <p data-id="element-2090" data-mp="z21y123sm5b1">Model: Android 14 (ডেমো)</p>
            <p data-id="element-2091" data-mp="141wmkz03iisx">Unit binding: ট্রাফিক-তেজগাঁও বিভাগ</p>
          </div>
        </div>
      </Modal>
    </div>;
}